export enum CatalogType {
    digitalWallet = 'DIGITAL_WALLET',
    loyaltyCollection = 'LOYALTY_COLLECTION',

}